import { createSelector } from "reselect";

const getConfigInfo = (state: any) => state && state.config;
const getSiteInfo = (state: any) => state && state["cbre-flow-site-location"].siteInfo;
const getAdminUserRoleState = (state: any) => state && state["cbre-flow-admin-user-role"];

// API URLs
export const getAdminUsersListUrl = createSelector(
  [getConfigInfo, getSiteInfo],
  (configInfo, siteInfo) =>
    configInfo && configInfo.client && configInfo.client.flowApiUrl
      ? `${configInfo.client.flowApiUrl}api/user/client-users`
      : '',
);

export const getAdminUserStatusCountUrl = createSelector(
  [getConfigInfo, getSiteInfo],
  (configInfo, siteInfo) =>
    configInfo && configInfo.client && configInfo.client.flowApiUrl
      ? `${configInfo.client.flowApiUrl}api/user/client-users/count?`
      : '',
);

export const getAdminAddUserUrl = createSelector(
  [getConfigInfo, getSiteInfo],
  (configInfo, siteInfo) =>
    configInfo && configInfo.client && configInfo.client.flowApiUrl
      ? `${configInfo.client.flowApiUrl}api/user/client-users`
      : '',
);
export const saveBulkUserUrl = createSelector(
  [getConfigInfo, getSiteInfo],
  (configInfo, siteInfo) =>
    configInfo && configInfo.client && configInfo.client.flowApiUrl
      ? `${configInfo.client.flowApiUrl}api/user/client-users/bulk`
      : '',
);

export const getAdminRolesUrl = createSelector(
  [getConfigInfo, getSiteInfo],
  (configInfo, siteInfo) =>
    configInfo && configInfo.client && configInfo.client.flowApiUrl
      ? `${configInfo.client.flowApiUrl}api/admin/roles`
      : '',
);

export const getAdminSitesUrl = createSelector(
  [getConfigInfo, getSiteInfo],
  (configInfo, siteInfo) =>
    configInfo && configInfo.client && configInfo.client.flowApiUrl
      ? `${configInfo.client.flowApiUrl}api/admin/sites`
      : '',
);

// State selectors
export const getTotalUsers = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.statusCounts.totalUsers : 0
);

export const getNeedApprovalCount = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.statusCounts.needApproval : 0
);

export const getIsLoading = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.isLoading : false
);

export const getFilters = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.filters : {}
);

export const getActiveStatus = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.activeStatus : null
);

export const getDrawerOpen = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.drawerOpen : false
);

export const getAddUserMode = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.addUserMode : 'add'
);

export const getSelectedRows = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.selectedRows : []
);

export const getAddUserForm = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.addUserForm : {}
);

export const getAddUserSuccess = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.addUserSuccess : 0
);

export const getRoles = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.roles : []
);

export const getRolesLoading = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.rolesLoading : false
);

export const getRolesError = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.error : null
);

export const getRolesList = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.rolesList : []
);

export const getRolesListLoading = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.rolesListLoading : false
);

export const getRolesListError = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.rolesListError : null
);

export const getClearSelectionCount = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.clearSelectionCount : 0
);

export const saveUserRoleFilterUrl = createSelector(
    [getConfigInfo],
    configInfo =>
        configInfo && configInfo.client && configInfo.client.flowApiUrl
            ? `${configInfo.client.flowApiUrl}api/site-info/update-user-config`
            : ''
);

export const getSelectedClient = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.selectedClient : null
);

export const getSelectedClientLoading = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.selectedClientLoading : false
);

export const getSelectedClientError = createSelector(
  [getAdminUserRoleState],
  (adminUserRoleState) => adminUserRoleState ? adminUserRoleState.selectedClientError : null
);